/** 申請種別の表示ラベル（#415 / FR-02-6） */

export const GEN1_APPLICATION_TYPE_LABEL_NEW_PURCHASE_ONLY =
    'New Purchase Only';
export const GEN1_APPLICATION_TYPE_LABEL_PURCHASED_ONLY = 'Purchased Only';

/**
 * IncludePurchasedRepeaters から申請種別ラベルを返す。
 * @param {boolean|undefined|null} includePurchasedRepeaters
 * @returns {string}
 */
export function getGen1ApplicationTypeLabel(includePurchasedRepeaters) {
    return includePurchasedRepeaters === true
        ? GEN1_APPLICATION_TYPE_LABEL_PURCHASED_ONLY
        : GEN1_APPLICATION_TYPE_LABEL_NEW_PURCHASE_ONLY;
}

/**
 * 購入済みリピーターあり申請（IncludePurchasedRepeaters === true）。
 * @param {{ IncludePurchasedRepeaters?: boolean }|null|undefined} order
 * @returns {boolean}
 */
export function includePurchasedRepeatersApplication(order) {
    return order?.IncludePurchasedRepeaters === true;
}
